import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers, defaultProps, withProps } from 'recompose';
import { partial, mapValues, pick } from 'lodash';
import withFetchDataLoader from '../../../common/hoc/withFetchDataLoader';
import Form from './Form';
import * as actions from './actions';
import * as selectors from './selectors';
import { trimFunction } from '../../../common/trimData';
import confirmModal from '../../../common/confirmModal';
import { getBarberUser, getShop, getShopBrandId, isBrandViewActive } from '../../../auth/selectors';
import withBaseUrlByRole from '../../../common/hoc/withBaseUrlByRole';

const mapStateToProps = (state, ownProps) => ({
  shop: getShop(state),
  barberUser: getBarberUser(state),
  isBrandUser: isBrandViewActive(state),
  brandId: getShopBrandId(state),
  initialValues: selectors.byId(state, ownProps.params.id),
});

const mapDispatchToProps = {
  onSubmit: actions.updateItem,
  onDelete: actions.deleteItem,
  fetchData: actions.fetchItem,
};

export default compose(
  withRouter,
  defaultProps({ title: 'Edit category', edit: true }),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(ownProps =>
    mapValues(pick(ownProps, ['onSubmit', 'onDelete', 'fetchData']), handler => partial(handler, ownProps.brandId))
  ),
  withBaseUrlByRole('/services/categories'),
  withHandlers({
    fetchData: props => () => {
      if (props.initialValues) return Promise.resolve();
      return props.fetchData(props.params.id);
    },
    onSubmit: props => trimFunction(values => props.onSubmit(props.params.id, values)),
    onDelete: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete item',
        message: 'Are you sure you want to delete item?',
      });

      if (confirmed) {
        await props.onDelete(props.params.id);
        props.router.push(props.baseUrl);
      }
    },
  }),
  withFetchDataLoader,
)(Form);
